<template>
  <body class="overflowHidden" id="fillInfo">
  <div class="wrapper"  >

    <main class="contentModule">
      <div class="space-between theme">
        <div>
          <div class="insuranceTheme">关税保证保险</div>
          <div class="insuranceDescription">由保险公司为企业提供关税担保，在货物通关时，凭借“一张保单”即可享受“先放行后缴税”</div>
        </div>
        <!--<button class="homePage" onmouseover="this.style.backgroundColor='#eff1f5';"
                onmouseout="this.style.backgroundColor='#ffffff';" onmouseup="this.style.backgroundColor='#f3f7fd';">
          返回首页
        </button>-->
      </div>
      <div class="fillInModule processOne"  v-if="processPageSwitch == 1"   >
        <div class="processProcedure">
          <div class="unit">
            <span>01</span>
            <span>投保申请</span>
          </div>
        </div>
        <ul>
          <li>
            <div>询价保险公司</div>
            <div class="dropdown" data-code="sellCompany" data-value="sellInsurePdtId">
              <el-select v-model="sellInsurePdtId" placeholder="请选择您意向的询价保险公司" >
                <el-option
                  v-for="item in sellCompanyData"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
              <!--<input type="text" readonly="readonly" placeholder="请选择您意向的询价保险公司" value="" class="sellInsurePdtId" @click="loadDropdownList('sellCompany' ,$event)">-->
              <!--<img src="../../images/dutyInsurance/triangularArrowheads.png" class="pullDown">-->
            </div>
          </li>
          <li>
            <div>通关海关</div>
            <!-- 下拉多选列表 -->
            <div class="dropdownSelector" data-value="insuredLists">
              <el-select
                v-model="customsValueList"
                multiple
                filterable
                clearable
                allow-create
                default-first-option
                placeholder="请选择通关海关">
                <el-option
                  v-for="item in customsData"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code">
                </el-option>
              </el-select>

              <!--<img src="../../images/dutyInsurance/triangularArrowheads.png" class="pullDown">-->
            </div>
          </li>
          <li>
            <div>备案海关</div>
            <div class="dropdown" data-code="customs" data-value="recordInsuredLists">
              <el-select v-model="customsValue" placeholder="请选择备案海关" >
                <el-option
                  v-for="item in customsData"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
             <!-- <input type="text" readonly="readonly" placeholder="请选择备案海关" class="recordPlaceCustomsCode"  @click="loadDropdownList('customs' ,$event)" >
              <img src="../../images/dutyInsurance/triangularArrowheads.png" class="pullDown">-->
            </div>
          </li>
          <li>
            <div>保单用途</div>
            <div class="dropdown" data-code="guaranteeCustomsDutiesCode" data-value="tariffPolicyPurposeCode"
                 data-splice="1">
              <el-select v-model="tariffPolicyPurposeValue" placeholder="请选择您的保单用途" >
                <el-option
                  v-for="item in tariffPolicyPurposeCodeData"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
              <!--<input type="text" readonly="readonly" placeholder="请选择您的保单用途" class="tariffPolicyPurposeCode" @click="loadDropdownList('guaranteeCustomsDutiesCode' ,$event)" >
              <img src="../../images/dutyInsurance/triangularArrowheads.png" class="pullDown">-->
            </div>
          </li>
          <li>
            <div>保单期限</div>
            <div class="dropdown" data-code="insurancePeriod" data-value="policyPeriod">
              <el-select  @change="insuranceChange" v-model="insurancePeriodValue" placeholder="请选择您的保单期限" >
                <el-option

                  v-for="item in insurancePeriodData"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
              <!--<input type="text" readonly="readonly" placeholder="请选择您的保单期限" class="policyPeriod" @click="loadDropdownList('insurancePeriod' ,$event)" >
              <img src="../../images/dutyInsurance/triangularArrowheads.png" class="pullDown">-->
            </div>
          </li>
          <li>
            <div class="flex-wrap">
              <span style="margin-right: .5rem">保单生效日期</span>
              <span class="useDatePrompt">*请您在保单生效日前完成投保并支付保费，否则订单作废。</span>
            </div>
            <div class="dateSelector" data-value="useDate">
                <el-date-picker
                  v-model="beInsuredEffectiveDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  align="center"
                  placeholder="请选择"
                  class="my-el-date-picker"
                  :picker-options="pickerOptions"
                  @change="effectiveDateChange"
                >
                </el-date-picker>
                <!--<input type="text" placeholder="请您在保单生效日前完成投保并支付保费" class="useDate" readonly>
                <img src="../../images/dutyInsurance/dateSelector.png">-->
            </div>
          </li>
          <li>
            <div>近一年纳税总额（元）</div>
            <div data-value="lastYearTax">
              <el-input
                placeholder="请输入上一年的纳税总额"
                @keyup.native="lastYearTax = changeSaleNum(lastYearTax)"
                v-model="lastYearTax"
              >
              </el-input>
             <!-- <input type="text" placeholder="请输入上一年的纳税总额"   v-model="lastYearTax"   class="lastYearTax"  autocomplete="off"   >-->
            </div>
          </li>
          <li>
            <div>投保金额（元）</div>
            <div data-value="insureAmount">
              <el-input
                placeholder="请输入您的投保金额"
                @keyup.native="insureAmount = changeSaleNum(insureAmount)"
                v-model="insureAmount"
              >
              </el-input>
           <!--   <input type="text" placeholder="请输入您的投保金额"   v-model="insureAmount" class="insureAmount" oninput="clearNoNum($event)">-->
            </div>
          </li>
        </ul>
        <div class="step space-around">
          <button class="nextStep" @click="nextStep(1)" data-value="1" onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">下一步</button>
        </div>
      </div>
      <div class="fillInModule processTwo"  v-if="processPageSwitch == 2">
        <div class="processProcedure">
          <div class="unit">
            <span>02</span>
            <span>企业信息</span>
          </div>
        </div>
        <ul>
          <li>
            <div>企业名称</div>
            <div data-value="policyHolderName" >
              <input type="text" placeholder="请按照营业执照信息填写企业名称" class="policyHolderName" v-model="policyHolderName">
            </div>
          </li>
          <li>
            <div>统一社会信用代码</div>
            <div data-value="identifyNumber">
              <input type="text" placeholder="请输入统一社会信用代码" class="identifyNumber"  v-model="identifyNumber">
            </div>
          </li>
          <li>
            <div>企业注册日期</div>
            <div class="dateSelector" data-value="brithday">
              <el-date-picker
                  v-model="brithday"
                  value-format="yyyy-MM-dd"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  align="center"
                  placeholder="请选择"
                  class="my-el-date-picker"
              >
              </el-date-picker>

              <!--<input type="text" placeholder="请选择企业注册日期" class="brithday" readonly>
              <img src="../../images/dutyInsurance/dateSelector.png">-->
            </div>
          </li>
          <li >
            <div>营业执照有效期</div>
            <div class="dateSelector" data-value="companyCardEndDate">
              <div class="longTermEffective" @click="longAffirm">
                            <span class="check_box whetherAgree">
                                <img class="checkbox" src="../../images/dutyInsurance/login/checkbox_no.png"
                                     data-check="0" v-if="isLongAffirm == 1">
                                <img class="checkbox isCheck" src="../../images/dutyInsurance/login/checkbox_yes.png" v-if="isLongAffirm == 2"
                                     data-check="1" >
                            </span>
                <span>长期有效</span>
              </div>
              <el-date-picker v-if="isLongAffirm == 1"
                v-model="companyCardEndDate"
                value-format="yyyy-MM-dd"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                align="center"
                placeholder="请选择"
                class="my-el-date-picker companyCardEndDate"
                :picker-options="pickerOptionsEndDate"
              >
              </el-date-picker><!--
              <input type="text" placeholder="请选择营业执照有效期" class="companyCardEndDate" readonly>
              <img src="../../images/dutyInsurance/dateSelector.png" class="companyCardEndDateImages">-->
            </div>
          </li>
          <li>
            <div>注册地址</div>
            <div data-value="registyAddress">
              <input type="text" placeholder="请输入营业执照上的企业注册地址" class="registyAddress"  v-model="registyAddress">
            </div>
          </li>
          <li>
            <div>法定代表人</div>
            <div data-value="corporationName">
              <input type="text" placeholder="请输入法人姓名" class="corporationName"  v-model="corporationName">
            </div>
          </li>
          <li>
            <div>证件类型</div>
            <div class="dropdown" data-code="certificates" data-value="corporationIdType">
              <el-select v-model="corporationIdType" placeholder="请选择法人证件类型" >
                <el-option
                  v-for="item in corporationIdTypeDate"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
              <!--<input type="text" readonly="readonly" placeholder="请选择法人证件类型" class="corporationIdType">
              <img src="../../images/dutyInsurance/triangularArrowheads.png" class="pullDown">-->
            </div>
          </li>
          <li>
            <div>法定代表证件号</div>
            <div data-value="corporationIdNum">
              <input type="text" placeholder="请输入法人证件号" onkeyup="value=value.replace(/[^\d]/g,'')" class="corporationIdNum"  v-model="corporationIdNum">
            </div>
          </li>
          <li>
            <div>企业联系人</div>
            <div data-value="linkerName">
              <input type="text" placeholder="请输入企业联系人姓名" class="linkerName" v-model="linkerName" >
            </div>
          </li>
          <li>
            <div>企业联系人手机号码</div>
            <!-- @input="if(value.length>11)value=value.slice(0,11)"-->
            <div data-value="mobile">
              <input type="text" onkeyup="value=value.replace(/[^\d\-\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)"
                     placeholder="请输入企业联系人手机号" class="mobile" v-model="mobile">
            </div>
          </li>
          <li>
            <div>企业联系电话</div>
            <div data-value="phone">
              <input type="text" onkeyup="value=value.replace(/[^\d\-\d]/g,'')" placeholder="请输入企业联系号码" class="phone" v-model="phone">
            </div>
          </li>
          <li>
            <div>企业注册所在地</div>
            <div class="dropdown" data-code="country" data-value="registeredPlaceCode" data-splice="1">
              <el-select v-model="registeredPlaceCode" placeholder="请选择企业注册所在地" >
                <el-option
                  v-for="item in registeredPlaceCodeData"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
             <!-- <input type="text" readonly="readonly" placeholder="请选择企业注册所在地" class="registeredPlaceCode">
              <img src="../../images/dutyInsurance/triangularArrowheads.png" class="pullDown">-->
            </div>
          </li>
          <li>
            <div>电子邮箱</div>
            <div data-value="email">
              <input type="email" placeholder="请注意，该邮箱用于接收电子保单，请谨慎填写" class="email" v-model="email" >
            </div>
          </li>
          <li>            <div>海关注册登记信用级别</div>
            <div class="dropdown" data-code="creditCode" data-value="customsCreditCategoryCode" data-splice="1">
              <el-select v-model="customsCreditCategoryCode" placeholder="请选择海关注册登记信用登记" >
                <el-option
                  v-for="item in customsCreditCategoryCodeDate"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
              <!--<input type="text" readonly="readonly" placeholder="请选择海关注册登记信用登记" class="customsCreditCategoryCode">
              <img src="../../images/dutyInsurance/triangularArrowheads.png" class="pullDown">-->
            </div>
          </li>
          <li>
            <div>企业海关代码</div>
            <div data-value="customsCompany">
              <input type="text" placeholder="请输入企业海关代码" class="customsCompany" v-model="customsCompany">
            </div>
          </li>

          <li>
            <div>组织机构</div>
            <div class="layui-form" data-value="organizationType">
              <el-cascader
                v-model="organizationType"
                :options="organizationTypeData"
                :props="{ label: 'name'}"
                @change="handleOrganizationChange"
                ref="organizationType"></el-cascader>
              <!--<select xm-select="organization" xm-select-radio>
              <option value="">请选择组织机构</option>
              </select>-->
            </div>
          </li>
          <li>
            <div>通讯地址</div>
            <div data-value="postAddress">
              <input type="text" placeholder="请输入通讯地址" class="postAddress" v-model="postAddress">
            </div>
          </li>
          <li>
            <div>行业</div>
            <div class="layui-form" data-value="industryCategoryValue">
              <el-cascader
                v-model="industryCategoryValue"
                :options="industryCategoryData"
                :props="{ label: 'name' }"
                ref="industryCategoryValue"
                @change="handleChange"></el-cascader>
              <!--<select xm-select="industry" xm-select-radio>
                <option value="">请选择行业</option>
              </select>-->
            </div>
          </li>
          <li>
            <div>投保人性质</div>
            <div class="dropdown" data-code="policyHolderCode" data-value="applicantNatureCode" data-splice="1">
              <el-select v-model="applicantNatureCode" placeholder="请选择投保人性质" >
                <el-option
                  v-for="item in applicantNatureCodeDate"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
              <!--<input type="text" readonly="readonly" placeholder="请选择投保人性质" class="applicantNatureCode">
              <img src="../../images/dutyInsurance/triangularArrowheads.png" class="pullDown">-->
            </div>
          </li>
        </ul>
        <div class="step flex-wrap">
          <button class="previousStep"   @click="previousStep(2)"  data-value="2" onmouseover="this.style.backgroundColor='#eff1f5';"
                  onmouseout="this.style.backgroundColor='#ececec';" onmouseup="this.style.backgroundColor='#f2f7fe';">
            上一步
          </button>
          <button class="nextStep" @click="nextStep(2)" data-value="2" onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">下一步</button>
        </div>
      </div>
      <div class="fillInModule processThree"  v-if="processPageSwitch == 3" >
        <div class="processProcedure">
          <div class="unit">
            <span>03</span>
            <span>上传附件</span>
          </div>
        </div>
        <ul>
          <li class="commitmentUrl">
            <div>承诺函</div>
            <div class="space-between commitmentUrl" data-value="commitmentUrl">
              <input type="file" readonly="readonly" placeholder="请上传相关文件" class="file" data-value="commitmentUrl">
              <span class="fileName">{{ this.$$.isValidObj(this.commitmentFileName) ? this.commitmentFileName : "请上传承诺函"}}</span>
              <div class="functionModule">
                <button class="downloadTemplate" @mouseover="borderColorOne='#49A9EE'" :style="borderColorOne"
                        @mouseout="borderColorOne='#108DE9'">
                  下载模板
                  <a
                    href="https://epolicy.xiaobaibao.com/doc/proposal/%E6%8A%95%E4%BF%9D%E4%BA%BA%E6%89%BF%E8%AF%BA%E5%87%BD%28%E6%B5%B7%E5%85%B3%29.pdf"
                    download="投保人承诺函(海关).pdf" target="_blank"></a>
                </button>
                <el-upload style="display: inline-block"
                           action="#"
                           :before-upload="(file) => beforeAvatarUpload(file, 1)"
                           :show-file-list="false"
                >
                  <el-button class="header-row-col-button-failure">选择上传<!--上传承诺函--></el-button>
                </el-upload>
              </div>
            </div>
          </li>
          <li class="licenseUrl">
            <div>营业执照</div>
            <div class="space-between licenseUrl" data-value="licenseUrl">
              <input type="file" readonly="readonly" placeholder="请上传相关文件" class="file" data-value="licenseUrl">
              <span class="fileName">{{ this.$$.isValidObj(this.licenseFileName) ? this.licenseFileName : "请上传营业执照副本扫描件文件"}}</span>
              <div class="functionModule">
                <el-button   class="header-row-col-button-failure" @click="showViewer = true">查看示例</el-button>
                <el-image-viewer
                  v-if="showViewer"
                  :on-close="()=>{showViewer=false}"
                  :url-list="licenseSrc">
                </el-image-viewer>
                <el-upload style="display: inline-block"
                           action="#"
                           :before-upload="(file) => beforeAvatarUpload(file, 2)"
                           :show-file-list="false"
                >
                  <el-button   class="header-row-col-button-failure">选择上传<!--上传营业执照--></el-button>
                </el-upload>
              </div>
            </div>
          </li>
          <li class="corporationUrl">
            <div>法人身份证</div>
            <div class="space-between" data-value="corporationUrl">
              <input type="file" readonly="readonly" placeholder="请上传相关文件" class="file" data-value="corporationUrl">
              <span class="fileName">{{ this.$$.isValidObj(this.corporationFileName)  ? this.corporationFileName : "请上传法人身份证人物面照片文件"}}</span>
              <div class="functionModule">
                <el-button   class="header-row-col-button-failure"  @click="showViewerTwo = true">查看示例</el-button>
                <!--<el-dialog
                  title="查看法人身份证示例"
                  :visible.sync="showViewerTwo"
                  width="30%"
                  center> <el-image :src="corporationSrc"></el-image>
                  <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="showViewerTwo = false">确 定</el-button>
                </span>
                </el-dialog>-->
                <el-image-viewer
                  v-if="showViewerTwo"
                  :on-close="()=>{showViewerTwo=false}"
                  :url-list="corporationSrc">
                </el-image-viewer>
                <el-upload style="display: inline-block"
                           action="#"
                           :before-upload="(file) => beforeAvatarUpload(file, 3)"
                           :show-file-list="false"
                >
                  <el-button class="header-row-col-button-failure">选择上传<!--上传营法人身份证--></el-button>
                </el-upload>
              </div>
            </div>
          </li>
          <li class="taxUrl" :style="taxIsUrlShow">
            <div>关税缴税清单</div>
            <div class="space-between" data-value="taxUrl">
              <input type="file" readonly="readonly" placeholder="上一年缴税总额大于两百万必选" class="file" data-value="taxUrl">
              <span class="fileName">{{this.$$.isValidObj(this.taxFileName) ? this.taxFileName : "请上传关税缴税清单"}}</span>
              <div class="functionModule">
                <button class="downloadTemplate" onmouseover="this.style.borderColor='#49A9EE';"
                        onmouseout="this.style.borderColor='#108DE9';">
                  下载模板
                  <a
                    href="https://epolicy.xiaobaibao.com/doc/proposal/%E6%8A%95%E4%BF%9D%E5%89%8D12%E4%B8%AA%E6%9C%88%E6%8A%95%E4%BF%9D%E4%BA%BA%E6%AF%8F%E6%9C%88%E7%BC%B4%E7%BA%B3%E6%B5%B7%E5%85%B3%E7%A8%8E%E6%AC%BE%E9%87%91%E9%A2%9D%E6%B1%87%E6%80%BB%E8%A1%A8.xlsx"
                    download="关税缴税清单.xlsx" target="_blank"></a>
                </button>
                <el-upload style="display: inline-block"
                           action="#"
                           :before-upload="(file) => beforeAvatarUpload(file, 4)"
                           :show-file-list="false"
                >
                  <el-button class="header-row-col-button-failure">选择上传<!--关税缴税清单--></el-button>
                </el-upload>
              </div>
            </div>
          </li>
          <li>
            <div>备注</div>
            <div>
              <input type="text" placeholder="备注信息" class="">
            </div>
          </li>
        </ul>
        <div class="step flex-wrap">
          <button class="previousStep" data-value="3" @click="previousStep(3)"   onmouseover="this.style.backgroundColor='#eff1f5';"
                  onmouseout="this.style.backgroundColor='#ececec';" onmouseup="this.style.backgroundColor='#f2f7fe';">上一步</button>
          <button @click="insureCheck(0)" class="save" data-status="0" data-value="3" onmouseover="this.style.borderColor='#ff8a73';" onmouseout="this.style.borderColor='#ff7052';">保存</button>
          <button @click="insureCheck(1)" class="insure" data-status="1" data-value="3" onmouseover="this.style.backgroundColor='#ff8a73';"
                  onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">投保</button>
          <!--<button @click="insureCheck(1)" class="insure" data-status="1" data-value="3" onmouseover="this.style.backgroundColor='#49A9EE';"
                  onmouseout="this.style.backgroundColor='#108DE9';" onmouseup="this.style.backgroundColor='#177FCF';">投保</button>-->
        </div>
      </div>
    </main>
    <!-- 弹窗 -->
    <div class="prompt" :style="promptSty">
      <div class="shadow"></div>
      <div class="promptContainer">
        <div class="promptTitle">正迅保险经纪有限公司客户告知书</div>
        <div class="promptContent">
          <div class="customerNotificationDetails">
            <div class="prefix">尊敬的客户：</div>
            <p>
              感谢您委托我司代为办理保险业务，本公司是基于投保人的利益，为投保人与保险公司订立保险合同提供中介服务的保险专业中介机构。为了保护您的合法权益，按照《保险经纪机构监管规定》的要求，本公司应履行客户告知义务，现将有关事项告知如下，请仔细阅读。</p>
            <p>一、公司基本情况</p>
            <p>（一）名称：正迅保险经纪有限公司</p>
            <p>（二）住所：广州市黄埔区开创大道2403号1003室</p>
            <p>（三）经营保险经纪业务许可证编码：260591000000800</p>
            <p>（四）经营保险经纪业务许可证有效期至：2021年09月28日</p>
            <p>（五）业务范围：</p>
            <p>
              第一类：在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国保监会批准的其他业务。</p>
            <p>第二类：经营互联网保险业务，备案名称：小白保险、保匣及万家保；经营许可证编号或者备案编号：粤ICP备13035223号-3。</p>
            <p>（六）经营区域：全国区域内（港、澳、台除外）</p>
            <p>（七）联系方式：020-62324288</p>
            <p>
              二、请仔细阅读保险条款，保险产品的广告、公告、彩页等宣传资料不属于保险合同的组成部分。请重点关注保险责任、责任免除或者除外责任、特别约定或扩展条款、投保资格要求、犹豫期后解除合同损失、投保人和被保险人权利义务、免赔额或免赔率的计算、等待期等，并可要求本公司业务人员对上述内容进行详细讲解。</p>
            <p>
              三、请向本公司客服人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果。</p>
            <p>四、根据《中华人民共和国保险法》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。</p>
            <p>五、本公司已按《保险经纪机构监管规定》投保职业责任保险。</p>
            <p>六、保险服务佣金收取方式：本次保险服务佣金由保险公司按保险法规定向我司支付。</p>
            <p>七、如果您发现本公司服务人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向本公司投诉（电话：020-62324288）。</p>
            <p style="font-weight: bold">我声明：正迅保险经纪有限公司的服务人员已向我讲解清楚投保的相关事项，我也对上述内容明确理解。</p>
            <div class="ending">正迅保险经纪有限公司</div>
          </div>
        </div>
        <div class="button">
          <button :style="readButton" @mouseenter="readButtonOnMouse('background-color: #df8e1d;')"
                  @click="closePrompt('display: none;')"
                  @mouseleave="readButtonOnMouse('background-color: #ff7052;')">
            <span>我已阅读此协议</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  </body>
</template>

<script>

    import customsDutiesCode from '../../jsonData/customsDutiesCode.js';  // 导入组件
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
    import licenseSrc from '../../../../src/components/images/haoLian/licenseTemplate.png'
    import corporationSrc from '../../../../src/components/images/haoLian/corporationTemplate.png'


    export default {
        name: "fillInfo",
        components: { ElImageViewer },
        data() {
            return {
                id:"",
                token: "",
                insuranceStatus: 0,             // 投保状态 [0：保存，1：投保]
                //pageTwoData1111111
                sellCompanyId: "10026",                                                 //渠道id
                sellCompanyData:  customsDutiesCode.customsDutiesCode()['sellCompany'],
                sellInsurePdtId: '',                                                      //询价保险公司
                customsData: customsDutiesCode.customsDutiesCode()['customs'],
                customsValue: '',                                                       //备案海关
                customsValueList: [],                                                   //通关海关
                tariffPolicyPurposeCodeData: customsDutiesCode.customsDutiesCode()['guaranteeCustomsDutiesCode'],
                tariffPolicyPurposeValue: '',                                           //关税保证保险单用途代码
                insurancePeriodData: customsDutiesCode.customsDutiesCode()['insurancePeriod'],
                insurancePeriodValue: '',                                               //保障期限
                beInsuredEffectiveDate: this.$$.dateAddDays( new Date().toDateString() , '3天' ), //保障生效日期
                effectiveDate: "",                                             //保单截至日期
                pickerOptions: {
                    disabledDate: this.disabledDate
                },
                lastYearTax:"",                                                           //上年保费
                insureAmount:"" ,                                                         //投保金额

                //企业名称 统一社会信用代码 企业注册日期 营业执照有效期 注册地址 法定代表人 证件类型 法定代表证件号 企业注册所在地 电子邮箱 海关注册登记信用级别 企业海关代码 组织机构 通讯地址 行业 投保人性质
                centerDialogVisible:false,
                //pageTwoData2222222
                policyHolderName:"" ,                                                  //企业
                identifyNumber:"" ,                                                    //统一社会信用代码
                brithday: this.$$.dateFormat(new Date()).toString() ,                  //企业注册日期
                companyCardEndDate: this.$$.dateAddDays(new Date().toDateString() , '1天' ), //营业执照有效期
                pickerOptionsEndDate: {
                    disabledDate: this.disabledDateTwo
                },
                isLongAffirm: 1,
                registyAddress:"" ,                                                    //注册地址
                corporationName:"" ,                                                   //法定代表人
                corporationIdType:"" ,                                                 //证件类型
                corporationIdTypeDate: customsDutiesCode.customsDutiesCode()['certificates'],
                corporationIdNum:"" ,                                                  //法定代表证件号
                linkerName:"",                                                         //企业联系人
                mobile:"",                                                             //企业联系人
                phone:"",                                                              //企业联系人
                registeredPlaceCode: "中国" ,                                       //企业注册所在地
                registeredPlaceCodeData: customsDutiesCode.customsDutiesCode()['country'],
                email:"" ,                                                             //电子邮箱
                customsCreditCategoryCode:"" ,                                         //海关注册登记信用级别
                customsCreditCategoryCodeDate: customsDutiesCode.customsDutiesCode()['creditCode'],
                customsCompany:"" ,                                                    //企业海关代码
                organizationType:"" ,                                                  //组织机构
                organizationTypeData: customsDutiesCode.customsDutiesCode()['companyType'],
                organizationTypeValue : "",
                organizationSecondTypeValue : "",

                postAddress:"" ,                                                       //通讯地址
                industryCategoryValue:"" ,                                                  //行业
                industryCategoryData: customsDutiesCode.customsDutiesCode()['industryCode'],
                industryCategory : "",                                                  //行业 one
                industrySCategory : "",                                                 //行业 two
                industryTCategory : "",                                                 //行业 three
                industryFCategory : "",                                                 //行业 four

                applicantNatureCode:"" ,                                               //投保人性质
                applicantNatureCodeDate: customsDutiesCode.customsDutiesCode()['policyHolderCode'],


                taxIsUrlShow : "display: none;",                                                   //大于20000万显示关税清单

                commitmentUrl:'',                                                      //承诺函
                commitmentFileName:'',                                                 //承诺函文件名字

                licenseUrl:'',                                                       //营业执照
                licenseFileName:'',                                                 //营业执照文件名字
                licenseSrc: [licenseSrc],
                corporationUrl:'',                                                      //法人身份证
                corporationFileName:'',                                                 //法人身份证文件名字
                corporationSrc: [corporationSrc],

                taxUrl:'',                                                            //关税缴税清单
                taxFileName:'',                                                      //关税缴税清单文件名字

                processPageSwitch: 1,
                borderColorOne:"",
                //样式逻辑
                readButton: "background-color: #ff7052;",             // 按钮样式
                processOne:'',                                        // 主页切换显示1
                processTwo:'display:none;',                           // 主页切换显示2
                processThree:'display:none;',                         // 主页切换显示3
                promptSty: "display:none;",                                        // 弹窗关闭

                showViewer: false, // 显示查看器
                showViewerTwo: false
            }
        },
        methods: {
            handleChange(value) {
                let labels = this.$refs["industryCategoryValue"].getCheckedNodes()[0].pathLabels;
                this.industryCategory =  value[0] + "-" + labels[0];
                this.industrySCategory = value[1] + "-" + labels[1];
                this.industryTCategory = value[2] + "-" + labels[2];
                this.industryFCategory = value[3] + "-" + labels[3];
            },
            handleOrganizationChange(value) {
                let labels = this.$refs["organizationType"].getCheckedNodes()[0].pathLabels;
                this.organizationTypeValue =  value[0] + "-" + labels[0];
                this.organizationSecondTypeValue = this.$$.isValidObj(value[1]) ? value[1] + "-" + labels[1] : "";
            },
            readButtonOnMouse(style) {
                this.readButton = style;

            },
            closePrompt(style) {
                this.promptSty = style;
            },
            disabledDate(time) {
                let _now = Date.now(),
                    day = 2 * 24 * 60 * 60 * 1000,
                    days = _now + day;
                return time.getTime() < days;
                //小于2天后的禁止
            },
            disabledDateTwo(time) {
                let _now = Date.now(),
                    day = 0 * 24 * 60 * 60 * 1000,
                    days = _now + day;
                return time.getTime() < days;
                //小于当前的禁止
            },
            insuranceChange(){
                if (this.$$.isValidObj(this.beInsuredEffectiveDate) && this.$$.isValidObj(this.$$.isValidObj(this.insurancePeriodValue))) {
                    let  effectiveDateItem = new Date(this.beInsuredEffectiveDate);
                    this.effectiveDate = this.$$.dateAddDays(effectiveDateItem.toDateString() , this.insurancePeriodValue + '月' );
                }
                console.log( this.effectiveDate );
            },
            //-- 保障生效时间获取页面数据 加保障期限
            effectiveDateChange() {
                if (this.$$.isValidObj(this.beInsuredEffectiveDate) && this.$$.isValidObj(this.$$.isValidObj(this.insurancePeriodValue))) {
                    let  effectiveDateItem = new Date(this.beInsuredEffectiveDate);
                    this.effectiveDate = this.$$.dateAddDays(effectiveDateItem.toDateString() , this.insurancePeriodValue + '月' );
                }
            },
            //金额验证
            changeSaleNum(value) {
                let length = value.length;
                value = value.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
                value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
                value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
                let valueList = value.split('.');
                if (valueList[0].length > 9) value = valueList[0].substring(0,9) + (this.$$.isValidObj(valueList[1]) ? '.'+valueList[1] : '');
                if (value.indexOf(".") < 0 && value !== "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                    value = parseFloat(value);
                }
                value = this.get_thousand_num(value);
                return value;
            },
            get_thousand_num(num) {
                return num.toString().replace(/\d+/, function (n) { // 先提取整数部分
                    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) { // 对整数部分添加分隔符
                        return $1 + ",";
                    });
                });
            },
            changePhoneNum(value) {
                let length = value.length;
                value = value.replace(/[^\d\-\d]/g,'');  //清除“数字”和“.”以外的字符
                let valueList = value.split('.');
                if (valueList[0].length > 11) value = valueList[0].substring(0,11) + (this.$$.isValidObj(valueList[1]) ? '.'+valueList[1] : '');
                return value;
            },
            longAffirm(){
                if(this.isLongAffirm == 1){
                    this.companyCardEndDate = '9999-01-01';
                    this.isLongAffirm = 2;
                }else{
                    let now = new Date(),
                        nowData = now.getDate(),
                        tomorrowDate = this.$$.dateFormat(new Date(now.setDate(nowData + 1)));
                    this.companyCardEndDate = tomorrowDate;
                    this.isLongAffirm = 1;
                }
            },
            dataIsValid() {

            },
            insureCheck(submitType){

                // console.log(this.commitmentUrl);
                // console.log("this.commitmentUrl");

                if (!this.$$.isValidObj(this.commitmentUrl)){
                    this.$message.error("请上传承诺函~");
                } else if (!this.$$.isValidObj(this.licenseUrl)){
                    this.$message.error("请上传营业执照~");
                } else if (!this.$$.isValidObj(this.corporationUrl)){
                    this.$message.error("请上传法人身份证~");
                } else if (!this.$$.isValidObj(this.taxUrl) && parseInt(this.insureAmount) > 2000000){
                    this.$message.error("请上传关税缴税清单~");
                } else {
                    this.submitOrder(submitType);
                }
            },
            // -- 订单提交
            submitOrder(submitType) {

                let params = {};//投保数据

                let prompt = '保存成功~';
                if (this.$$.isValidObj(this.id)) {
                    params['orderIdNum'] = this.id;
                    prompt = '编辑成功~';
                }
                if (submitType == 1) {
                    params['insuranceFlag'] = true;
                    prompt = '投保成功~';
                }
                params['sellCompanyId'] = this.sellCompanyId;//渠道公司
                params['sellInsurePdtId'] = this.sellInsurePdtId;//询价保险公司
                let  tariffPolicyPurposeValueTrue = "";
                this.tariffPolicyPurposeCodeData.forEach(item => {
                    if (this.tariffPolicyPurposeValue == item.code){
                        tariffPolicyPurposeValueTrue = item.code + "-" +item.label;
                    }
                });
                params['tariffPolicyPurposeCode'] = tariffPolicyPurposeValueTrue;//关税保证保险单用途代码
                let insuredList = [];
                //通过海关
                this.customsValueList.forEach(itemCode => {
                    let customs = {};
                    this.customsData.forEach(itemTwo =>{
                        if (itemCode == itemTwo.code){
                            customs['clearanceCustomsCode'] = itemTwo.code;
                            customs["insuredName"]  = itemTwo.label;
                            customs["insuredIdNum"] = itemTwo.organisationCode;
                            customs["insuredIdType"]  = 6;
                        }
                    });
                    insuredList.push(customs);
                });
                //备案海关
                this.customsData.forEach(itemTwo =>{
                    let recordPlaceCustoms = {};
                    if ( this.customsValue == itemTwo.code){
                        recordPlaceCustoms['recordPlaceCustomsCode'] = itemTwo.code;
                        recordPlaceCustoms["insuredName"]  = itemTwo.label;
                        recordPlaceCustoms["insuredIdNum"] = itemTwo.organisationCode;
                        recordPlaceCustoms["insuredIdType"]  = 6;
                        insuredList.push(recordPlaceCustoms);
                    }
                });

                params['insuredList'] = insuredList;//all 海关
                params['effectiveDate'] =  this.beInsuredEffectiveDate;// 保障生效时间
                params['expireDate'] =  this.effectiveDate;//
                params['lastYearTax'] =  this.lastYearTax.replace(/,/g, "");// 上年保费
                params['insureAmount'] =  this.insureAmount.replace(/,/g, "");// 投保金额

                //------第二页数据提交
                params['policyHolderName'] =  this.policyHolderName;
                params['identifyNumber'] =  this.identifyNumber;
                params['brithday'] =  this.brithday;
                params['companyCardEndDate'] =  this.companyCardEndDate;
                params['registyAddress'] =  this.registyAddress;
                params['corporationName'] =  this.corporationName;
                params['corporationIdType'] =  this.corporationIdType;
                params['corporationIdNum'] =  this.corporationIdNum;

                this.registeredPlaceCodeData.forEach(item => {
                    if(item.label == this.registeredPlaceCode){
                        params['registeredPlaceCode'] = item.code + "-" + item.label;
                    }
                });

                params['email'] =  this.email;
                params['linkerName'] =  this.linkerName;
                params['phone'] =  this.phone;
                params['mobile'] =  this.mobile;

                params['identifyType'] = "6";//证件类型 =6
                this.customsCreditCategoryCodeDate.forEach(item => {
                    if(item.code == this.customsCreditCategoryCode){
                        params['customsCreditCategoryCode'] = item.code + "-" + item.label;
                    }
                });
                params['customsCompany'] =  this.customsCompany;
                //行业代码
                params['industryCategory'] = this.industryCategory;
                params['industrySCategory'] = this.industrySCategory;
                params['industryTCategory'] = this.industryTCategory;
                params['industryFCategory'] = this.industryFCategory;

                params['postAddress'] = this.postAddress;

                //机构代码
                params['organizationType'] = this.organizationTypeValue;
                params['organizationSecondType'] = this.organizationSecondTypeValue;
                this.applicantNatureCodeDate.forEach(item => {
                    if(item.code == this.applicantNatureCode){
                        params['applicantNatureCode'] = item.code + "-" + item.label;
                    }
                });
                params['commitmentUrl'] = this.commitmentUrl;
                params['licenseUrl'] = this.licenseUrl;
                params['corporationUrl'] = this.corporationUrl;
                if(parseInt(this.insureAmount.replace(/,/g, "")) > 2000000){
                    params['taxUrl'] = this.taxUrl;
                }
                console.log(params);
                this.axios.post('/management/tariffInsurance/customsGuaranteeApply', params).then((response) => {
                    if (response.data.success) {
                        //-- 会话存储 - 参数
                        // this.src = "";
                        console.log("请求成功");
                    } else {
                        this.$message.error(response.data.msg);
                    }
                });
            },
            beforeAvatarUpload(file , typeSwitch) {

                this.$confirm("确定是否要上传《"+file.name+"》文件吗？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
                        this.$message.error('只能上传png、jpg文件');
                        return false;
                    }

                    console.log("filePathUrl");
                    let that = this;
                    const formData = new window.FormData();
                    formData.append('file', file);
                    formData.append('formType', '20008');
                    // formData.append('formId', '-1');
                    console.log(formData);
                    console.log("formData");
                    that.axios.post('/upload/attachment/upload', formData ).then((response) => {
                        let data = response.data;
                        console.log(data);
                        if (data.success) {
                            //图片路径
                            switch (typeSwitch) {
                                case 1 :
                                    this.commitmentUrl = data.datas.filePath;
                                    this.commitmentFileName = data.datas.fileName;
                                    break;
                                case 2 :

                                    this.licenseUrl = data.datas.filePath;
                                    this.licenseFileName = data.datas.fileName;
                                    break;
                                case 3 :
                                    this.corporationUrl = data.datas.filePath;
                                    this.corporationFileName = data.datas.fileName;
                                    break;
                                case 4 :
                                    this.taxUrl = data.datas.filePath;
                                    this.taxFileName = data.datas.fileName;
                                    break;
                            }

                            console.log(filePathUrl);
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                    this.$message({
                        type: 'success',
                        message: '上传成功!'
                    });
                }).catch(() => {
                });
                return false;

            },
            nextStep(type){

                let notEmptyState = true,
                    label = '',
                    reg_creditCode = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g,                                                 // 统一社会信用代码正则
                    reg_mobile = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/,                  // 11位手机号码正则
                    reg_phone = /^(0\d{2,3})-?(\d{7,8})$/,                                                                          // 座机号码正则
                    reg_email = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;     // 邮箱正则
                if(type == 1){
                    //第一页数据
                    if (!this.$$.isValidObj(this.sellInsurePdtId)){
                        label = 'sellInsurePdtId';
                        this.$message.error("请选择询价机构~");
                    } else if (Object.keys(this.customsValueList).length <= 0){
                        label = 'insuredLists';
                        this.$message.error("请选择通关海关~");
                    } else if (!this.$$.isValidObj(this.customsValue)){
                        label = 'recordInsuredLists';
                        this.$message.error("请选择备案海关~");
                    } else if (!this.$$.isValidObj(this.tariffPolicyPurposeValue)){
                        label = 'tariffPolicyPurposeCode';
                        this.$message.error("请选择保单用途~");
                    } else if (!this.$$.isValidObj(this.insurancePeriodValue)){
                        label = 'policyPeriod';
                        this.$message.error("请选择保单期限~");
                    } else if (!this.$$.isValidObj(this.beInsuredEffectiveDate)){
                        label = 'useDate';
                        this.$message.error("请选择您的预计保单使用期限~");
                    } else if (!this.$$.isValidObj(this.lastYearTax)){
                        label = 'lastYearTax';
                        this.$message.error("请输入上一年的纳税总额~");
                    } else if (!this.$$.isValidObj(this.insureAmount)){
                        label = 'insureAmount';
                        this.$message.error("请输入投保金额~");
                    } else if (type == 1){
                        let reg = new RegExp(",","g");
                        let  insureAmountReplace = this.insureAmount.replace(reg, '');

                        if (parseInt(insureAmountReplace) > 2000000){
                            this.taxIsUrlShow = "display:block;";
                        } else {
                            this.taxIsUrlShow = "display:none;";
                        }
                        this.processPageSwitch = 2;
                    }
                }else if(type == 2){
                    //第二页数据

                    if (!this.$$.isValidObj(this.policyHolderName)){
                        label = 'policyHolderName';
                        this.$message.error("请输入询价公司~");
                    } else if (!this.$$.isValidObj(this.identifyNumber)){
                        label = 'identifyNumber';
                        this.$message.error("请输入统一社会信用代码~");
                    } else if (!reg_creditCode.test(this.identifyNumber)){
                        label = 'identifyNumber';
                        this.$message.error("请输入正确的统一社会信用代码~");
                    } else if (!this.$$.isValidObj(this.brithday)){
                        label = 'brithday';
                        this.$message.error("请选择企业注册日期~");
                    } else if (!this.$$.isValidObj(this.companyCardEndDate)){
                        label = 'companyCardEndDate';
                        this.$message.error("请选择营业执照有效期~");
                    } else if (!this.$$.isValidObj(this.registyAddress)){
                        label = 'registyAddress';
                        this.$message.error("请输入企业注册地址~");
                    } else if (!this.$$.isValidObj(this.corporationName)){
                        label = 'corporationName';
                        this.$message.error("请输入法人姓名~");
                    } else if (!this.$$.isValidObj(this.corporationIdType)){
                        label = 'corporationIdType';
                        this.$message.error("请选择法人证件类型~");
                    } else if (!this.$$.isValidObj(this.corporationIdNum)){
                        label = 'corporationIdNum';
                        this.$message.error("请输入法人证件号~");
                    } else if (!this.verifyCertificatesType(this.corporationIdNum)){
                        label = 'corporationIdNum';
                        this.$message.error("请输入有效的法人证件号~");
                    } else if (!this.$$.isValidObj(this.linkerName)){
                        label = 'linkerName';
                        this.$message.error("请输入企业联系人姓名~");
                    } else if (!this.$$.isValidObj(this.mobile)){
                        label = 'mobile';
                        this.$message.error("请输入企业联系人手机号~");
                    } else if (!reg_mobile.test(this.mobile)){
                        label = 'mobile';
                        this.$message.error("请输入正确的企业联系人手机号~");
                    } else if (!this.$$.isValidObj(this.phone)){
                        label = 'phone';
                        this.$message.error("请输入企业联系号码~");
                    } else if (!reg_phone.test(this.phone)){
                        label = 'phone';
                        this.$message.error("请输入正确的企业联系号码~");
                    } else if (!this.$$.isValidObj(this.email)){
                        label = 'email';
                        this.$message.error("请输入电子邮箱地址~");
                    } else if (!reg_email.test(this.email)){
                        label = 'email';
                        this.$message.error("请输入正确的电子邮箱地址~");
                    } else if (!this.$$.isValidObj(this.customsCreditCategoryCode)){
                        label = 'customsCreditCategoryCode';
                        this.$message.error("请选择海关注册登记信用登记~");
                    } else if (!this.$$.isValidObj(this.customsCompany)){
                        label = 'customsCompany';
                        this.$message.error("请输入企业海关代码~");
                    } else if (!this.$$.isValidObj(this.organizationType)){
                        label = 'organizationType';
                        this.$message.error("请选择组织机构~");
                    } else if (!this.$$.isValidObj(this.postAddress)){
                        label = 'postAddress';
                        this.$message.error("请输入通讯地址~");
                    } else if (!this.$$.isValidObj(this.industryCategoryValue)){
                        label = 'industryCategoryValue';
                        this.$message.error("请选择行业~");
                    } else if (!this.$$.isValidObj(this.applicantNatureCode)){
                        label = 'applicantNatureCode';
                        this.$message.error("请选择投保人性质~");
                    } else if (type ==  2){
                        notEmptyState = false;
                        this.processPageSwitch = 3;
                    }

                }
            },
            previousStep(type){
                switch (type) {
                    case 2:{
                        this.processPageSwitch = 1;
                        break;
                    }
                    case 3:{
                        this.processPageSwitch = 2;
                        break;
                    }
                }
            },
            verifyCertificatesType(certificates) {
                let certificatesType = {
                    cPassportReg: /^([a-zA-z]|[0-9]){5,17}$/,       // 中国护照
                    wPassportReg: /^[1][3,4,5,7,8][0-9]{9}$/,       // 外国护照
                    birthCardReg: /[A-Z]{1}\d{9}/,                  // 出生证
                    homeReg: /^[a-zA-Z0-9]{6,10}$/,                 // 澳台通行证、回乡证
                    creditReg: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,        // 统一社会信用代码
                    tissueReg: /[0-9A-HJ-NPQRTUWXY]{9}/,            // 组织机构代码证
                    taxReg: /^[0-9a-zA-z_]{18}$/,                   // 税务登记号
                    businessReg: /^[a-zA-Z0-9]{10,20}$/,            // 营业执照
                };
                // const dateUtil = new $Valid.validComment({}),
                //     {corporationIdType} = this.corporationIdType;

                switch (this.corporationIdType) {
                    case "1":{
                        return this.$$.constant.beInsureIdTypeOneReg.test(certificates) == true;
                    }
                    case "3":{
                        return certificatesType.cPassportReg.test(certificates);
                    }
                    case "5":{
                        return certificatesType.homeReg.test(certificates);
                    }
                    /*case "6":{
                        return certificatesType.creditReg.test(certificates);
                    }*/
                    case "10":{
                        return certificatesType.wPassportReg.test(certificates);
                    }
                    case "11":{
                        return certificatesType.tissueReg.test(certificates);
                    }
                }
                return false;
            }
            ,
            //-- 订单详情 - 数据编辑
            loadOrderDetails(){
                this.axios.post('/management/tariffInsurance/customsGuaranteeDetail?id='+ this.id).then((response) => {
                    if (response.data.success) {
                        this.dataProcessing(response.data['datas']);
                    } else {
                        this.$message.error(response.data.msg);
                    }
                });
            },
            dataProcessing(params){
                this.sellInsurePdtId = params['sellInsurePdtId'] ;//询价保险公司
                this.tariffPolicyPurposeValue = params['tariffPolicyPurposeCode'] ;//关税保证保险单用途代码
                let insuredList = [];
                let cleanCustom = params['cleanCustom'];
                let cleanCustomList = cleanCustom.split(",");
                //通过海关
                cleanCustomList.forEach(itemLabel => {
                    this.customsData.forEach(itemTwo =>{
                        if (itemLabel == itemTwo.label){
                            insuredList.push(itemTwo.code);
                        }
                    });
                });
                this.customsValueList = insuredList;
                let recordCustom = params['recordCustom'] ;
                //备案海关
                this.customsData.forEach(itemTwo =>{
                    if (recordCustom == itemTwo.label){
                        this.customsValue = itemTwo.code;
                    }
                });
                let effectiveDate = params['effectiveDate'];
                let expireDate = params['expireDate'];
                let startTime = new Date(effectiveDate),
                    endTime = new Date(expireDate),
                    policyPeriod = (endTime.getFullYear() - startTime.getFullYear()) * 12 + endTime.getMonth() - startTime.getMonth();

                // 保单期限
                let now = new Date(this.$$.dateFormat(new Date()) + ' 00:00:00'),
                tomorrow = this.$$.getTimeStamp(new Date(now.setDate(now.getDate() + 3)));
                if (this.$$.getTimeStamp(startTime) > tomorrow) this.beInsuredEffectiveDate  = params['effectiveDate'];

                this.effectiveDate = params['expireDate'];
                this.insurancePeriodValue =  policyPeriod < 10 ? '0' + policyPeriod : policyPeriod;
                this.lastYearTax = this.changeSaleNum( params['lastYearTax'] );// 上年保费
                this.insureAmount = this.changeSaleNum( params['insureAmount'] ) ;// 投保金额
                this.policyHolderName = params['policyHolderName'] ;
                this.identifyNumber = params['identifyNumber'] ;
                let brithdays = params['brithday'] ;
                this.brithday = brithdays.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");

                // 营业执照有效期
                let companyCardEndDate = params['companyCardEndDate'];
                if (this.$$.getTimeStamp(new Date(companyCardEndDate)) > this.$$.getTimeStamp()){
                  companyCardEndDate == '9999-01-01' ? this.isLongAffirm = 2 : this.companyCardEndDate = companyCardEndDate;
                }

                this.registyAddress = params['registyAddress'];
                this.corporationName = params['corporationName'];
                this.corporationIdType = params['corporationIdType'];
                this.corporationIdNum = params['corporationIdNum'];
                this.email = params['email'];
                this.linkerName = params['linkerName'];
                this.phone = params['phone'];
                this.mobile = params['mobile'];
                this.registeredPlaceCode =  params['registeredPlaceCode'];
                this.customsCreditCategoryCode = params['customsCreditCategoryCode'];
                this.customsCompany = params['customsCompany'];
                this.postAddress = params['postAddress'];
                this.applicantNatureCode = params['applicantNatureCode'];
                //行业代码
                let industryCategoryList = [params['industryCategory']  ,params['industrySCategory']  ,params['industryTCategory'] ,params['industryFCategory']];
                this.industryCategoryData.forEach(item =>{
                    if(item.value == params['industryCategory']){
                        this.industryCategory = item.value + "-" + item.name;
                        item.children.forEach(itemTwo =>{
                            if(itemTwo.value == params['industrySCategory'] ){
                                this.industrySCategory = itemTwo.value + "-" + itemTwo.name;
                                itemTwo.children.forEach(itemThree =>{
                                    if(itemThree.value == params['industryTCategory'] ){
                                        this.industryTCategory = itemThree.value + "-" + itemThree.name;
                                        itemThree.children.forEach(itemFour =>{
                                            if(itemFour.value == params['industryFCategory'] ){
                                                this.industryFCategory = itemFour.value + "-" + itemFour.name;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
                this.industryCategoryValue = industryCategoryList;

                this.organizationTypeData.forEach(item =>{
                    if(item.value == params['organizationType'] ){
                        this.organizationTypeValue = item.value + "-" + item.name;
                        if(this.$$.isValidObj(item.children)){
                            item.children.forEach(itemTwo =>{
                                if(itemTwo.value == params['organizationSecondType'] )
                                    this.organizationSecondTypeValue = itemTwo.value + "-" + itemTwo.name;
                            });
                        }
                    }
                });

                let organizationTypeList = params['organizationSecondType'] ? [params['organizationType'] ,params['organizationSecondType'] ] : [params['organizationType']];
                this.organizationType = organizationTypeList;
                this.commitmentUrl = params['commitmentUrl'];
                this.licenseUrl = params['licenseUrl'];
                this.corporationUrl = params['corporationUrl'];

                this.commitmentFileName = "已上传承诺函";
                this.licenseFileName = "已上传营业执照副本扫描件文件";
                this.corporationFileName = "已上传法人身份证人物面照片文件;";
                let reg = new RegExp(",","g");
                let  insureAmountReplace = this.insureAmount.replace(reg, '');
                if(parseInt(insureAmountReplace) > 2000000 &&  this.$$.isValidObj(params['taxUrl'])){
                    this.taxUrl = params['taxUrl'];
                    this.taxFileName = "已上传关税缴税清单文件";
                    this.taxIsUrlShow = "display:block;";
                }
            }
        },
        mounted() {
            this.id = this.$route.query.id;

            if (this.$$.isValidObj(this.id)) {
                 this.loadOrderDetails();
            }

            //-- 保单期限
            let now = new Date(),
              nowData = now.getDate();
            let maxSelectDate = this.$$.dateFormat(new Date(now.setDate(nowData + 3)));
            this.beInsuredEffectiveDate = maxSelectDate;

            //-- 营业执照有效期
            let tomorrowDate = this.$$.dateFormat(new Date(now.setDate(nowData + 1)));
            this.companyCardEndDate = tomorrowDate;
        },

    }
</script>

<style scoped>
  @import "../../../../static/css/dutyInsurance/fillInfo.css";

  /* 内容 */
  .fillInModule /deep/ .el-input__inner {
    border: none;
    padding: 0;
  }

  .dateSelector /deep/ .el-input__inner {
    padding: 0 30px;
  }

  .fillInModule /deep/ .el-select,
  .fillInModule /deep/ .el-cascader{
    display: block;
  }

  .fillInModule /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
  }

  /* 上传按钮 */
  .fillInModule /deep/ .el-button{
    width: 6.25rem;
    height: 2.5rem;
    line-height: 2.5rem;
    color: #FFFFFF;
    background: #ff7052;
    border-radius: 0.75rem;
    padding: 0;
    margin-bottom: 3px;
  }

  /deep/ .el-image-viewer__canvas{
    width: 70%;
    height: 100%;
    padding: 8% 0;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/dutyInsurance/fillInfo.vue